import { saveToLocalStorage } from '@/common/utils/localStorage';
import trackMixpanelEvent from '@/common/utils/mixpanel';
import { Button } from '@shadcn/components/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@shadcn/components/dialog';
import { useNavigate } from 'react-router-dom';

interface LessonPlanCtaModalProps {
  isOpen: boolean;
  onClose: () => void;
  content: string;
  name: string;
}

export default function LessonPlanCtaModal({
  isOpen,
  onClose,
  content,
  name,
}: LessonPlanCtaModalProps) {
  const navigate = useNavigate();

  function handleOpenChange(open: boolean) {
    if (!open) {
      trackMixpanelEvent('Lesson Plan Save CTA Modal Dismissed', {
        source: 'lessonplan-micronav',
      });
      onClose();
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-[640px] max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="text-xl">
            Save & edit Lesson Plans for free
          </DialogTitle>
          <DialogDescription>
            You can save and edit Lesson Plans for free with a Spellcaster
            account. Create, customise, and save multiple lesson plans for you
            and your team.
          </DialogDescription>
        </DialogHeader>

        <div className="flex items-center justify-between pt-2">
          <Button
            variant="link"
            className="px-0 text-sm"
            onClick={() => {
              trackMixpanelEvent('Lesson Plan Save CTA Log In Clicked', {
                source: 'lessonplan-micronav',
              });
              saveToLocalStorage('lessonPlanDraft', JSON.stringify({ content, name }));
              saveToLocalStorage('redirect', '/dashboard/lessonplans/new?from=public');
              onClose();
              navigate('/login');
            }}
          >
            Already have an account? Log in
          </Button>
          <Button
            onClick={() => {
              trackMixpanelEvent('Lesson Plan Save CTA Sign Up Clicked', {
                source: 'lessonplan-micronav',
              });
              saveToLocalStorage('lessonPlanDraft', JSON.stringify({ content, name }));
              saveToLocalStorage('redirect', '/dashboard/lessonplans/new?from=public');
              onClose();
              navigate('/signup');
            }}
          >
            Sign up for free
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
